import { Component, Input } from '@angular/core';
import { MatLegacySnackBarRef as MatSnackBarRef } from '@angular/material/legacy-snack-bar';
import { ZefSnackInput } from '@zerops/zef/snack';

@Component({
  selector: 'zui-snack-info',
  templateUrl: './snack-info.container.html',
  styleUrls: [ './snack-info.container.scss' ]
})
export class SnackInfoContainer {
  @Input()
  data: ZefSnackInput;

  @Input()
  instance: MatSnackBarRef<any>;
}
